import {
  SetStateAction,
  Dispatch,
  createContext,
  ReactNode,
  useState,
  useContext,
} from 'react';
import { IMergedAnsweredItem } from '@/types';

interface MergedAnsweredItemsContextProps {
  children: ReactNode;
}

type MergedAnsweredItemsContextData = {
  mergedAnsweredItems: IMergedAnsweredItem[];
  setMergedAnsweredItems: Dispatch<SetStateAction<IMergedAnsweredItem[]>>;
};

export const MergedAnsweredItemsContext =
  createContext<MergedAnsweredItemsContextData>(
    {} as MergedAnsweredItemsContextData
  );

export function MergedAnsweredItemsProvider({
  children,
}: MergedAnsweredItemsContextProps) {
  const [mergedAnsweredItems, setMergedAnsweredItems] = useState(
    [] as IMergedAnsweredItem[]
  );
  return (
    <MergedAnsweredItemsContext.Provider
      value={{
        mergedAnsweredItems: mergedAnsweredItems,
        setMergedAnsweredItems: setMergedAnsweredItems,
      }}
    >
      {children}
    </MergedAnsweredItemsContext.Provider>
  );
}

export const useMergedAnsweredItems = () => {
  const context = useContext(MergedAnsweredItemsContext);

  if (!context) {
    throw Error('Must be inside a MergedAnsweredItemsProvider');
  }

  return context;
};
